// router.js

import { createRouter, createWebHistory } from 'vue-router';
import Service from './components/Service.vue';
import PricePage from './components/PricePage.vue'
// 导入你的组件
import HomePage from './components/HomePage.vue';
import AboutPage from './components/About.vue';
import SelectMask from './components/SelectMask.vue'
import MaskDetail from './components/MaskDetail.vue'
import AccountPage from './components/Account.vue';
import MobileCheckout from './components/MobileCheckout.vue';
import PaymentCallback from './components/PaymentCallback.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/about',
    name: 'about',
    component: AboutPage
  },
  {
    path: '/service',
    name: 'service',
    component: Service
  },
  {
    path: '/price',
    name: 'price',
    component: PricePage
  },
  {
    path: '/mask',
    name: 'mask',
    component: SelectMask
  },
  {
    path: '/mask/:slug',
    name: 'mask-detail',
    component: MaskDetail
  },
  {
    path: '/account',
    name: 'account',
    component: AccountPage
  },
  {
    path: '/mobile-checkout',
    name: 'mobile-checkout',
    component: MobileCheckout
  },
  {
    path: '/payment-callback',
    name: 'payment-callback',
    component: PaymentCallback
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
